import {Injectable} from '@angular/core';
import {CrudImplementation} from '@shared/services/crud-implementation';
import {Observable} from 'rxjs';
import {CrudNewImplementation} from '@shared/services/crud-new-implementation';

@Injectable({
  providedIn: 'root'
})
export class CrudFlagsService extends CrudNewImplementation {
  protected url = '/v1/admin/flags';

  getFlagsByMandantFlagcategorykey(): Observable<any> {
    const url = this.url + '?flagcategorykey=mandant';
    return this.http.get(this.serverRoot + url);
  }

  getFlagsByEnvnameFlagcategorykey(): Observable<any> {
    const url = this.url + '?flagcategorykey=envname';
    return this.http.get(this.serverRoot + url);
  }

  getFlagsByToolgroupFlagcategorykey(): Observable<any> {
    const url = this.url + '?flagcategorykey=toolgroup';
    return this.http.get(this.serverRoot + url);
  }
}
